import React, { useState, useEffect } from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    useSearchParams,
    useLocation
} from 'react-router-dom';
import { MapContainer, TileLayer } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import Header from './components/ui/mainScreen/header';
import UserInterface from './components/ui/UserInterface';
import ViewRoadNetwork from './services/ViewRoadNetwork';
import GeoLocationNotifier from './utils/GeoLocationNotifier';
import EditableRoadNetwork from './services/EditableRoadNetwork';
import AuthWrapper from './services/AuthWrapper';
import ZoomControl from './components/ui/mainScreen/ZoomControl';
//import SearchContextWrapper from '../src/services/SearchContextWrapper';

//import FiltersComponent from './components/ui/modalsContent/FiltersComponent';
import { FilterProvider } from './utils/FilterContext';
import { SearchProvider } from './utils/SearchContext';
import { ModalStackProvider } from './utils/ModalStackContext';
import { RouteProvider} from "./utils/RouteContext";

import bigPictaSvg from './assets/icons/my-location-picta.svg';

const userIcon = L.icon({
    iconUrl: bigPictaSvg,
    className: 'user-location-icon',
});

function MapComponents({
                           roadsData,
                           bounds,
                           userIcon,
                           handlePositionUpdate,
                           handleStreetNameUpdate,
                           currentStreetName,
                       }) {
    // 1) проверяем логин-пароль
    const [searchParams] = useSearchParams();
    const login = searchParams.get('login');
    const password = searchParams.get('password');
    const isEditing = login === 'admin' && password === 'secret';

    // 2) узнаём текущий путь
    const { pathname } = useLocation();

    // 3) собираем модули в зависимости от трёх кейсов
    let modules = null;

    if (isEditing) {
        // — режим редактирования: модулей нет
        modules = (
            <>
                <Header message={currentStreetName} />
            </>
        );
    } else if (pathname === '/panorama') {
        // — панорамный режим: показываем только два модуля
        modules = (
            <>
                {roadsData && <ViewRoadNetwork roadsData={roadsData} />}
                <GeoLocationNotifier
                    bounds={bounds}
                    roadsData={roadsData}
                    userIcon={userIcon}
                    onPositionUpdate={handlePositionUpdate}
                    onStreetNameUpdate={handleStreetNameUpdate}
                />
                <ZoomControl bounds={bounds} />
            </>

        );
    } else {
        // — обычный просмотр (не редактирование, не панорама)
        modules = (
            <>
                {roadsData && <ViewRoadNetwork roadsData={roadsData} />}
                <GeoLocationNotifier
                    bounds={bounds}
                    roadsData={roadsData}
                    userIcon={userIcon}
                    onPositionUpdate={handlePositionUpdate}
                    onStreetNameUpdate={handleStreetNameUpdate}
                />
                <UserInterface />
                <ZoomControl bounds={bounds} />
                <Header message={currentStreetName} />
            </>
        );
    }

    return (
        <>
            {modules}



            <Routes>
                <Route
                    path="/"
                    element={
                        <AuthWrapper>
                            <EditableRoadNetwork onSaved={data => console.log('Saved:', data)} />
                        </AuthWrapper>
                    }
                />
                <Route
                    path="/panorama"
                    element={
                        // если нужно отдельное оформление для /panorama
                        <div className="panorama-fullscreen">
                            <Header message={currentStreetName} />
                        </div>
                    }
                />
            </Routes>
        </>
    );
}
function App() {
    //const [showFilters, setShowFilters] = useState(false);
    // Метаданные для границ
    const metadataBounds = [49.90120422, 40.5561735, 49.99681521, 40.60560169];
    const bounds = L.latLngBounds(
        [metadataBounds[1], metadataBounds[0]],
        [metadataBounds[3], metadataBounds[2]]
    );
    const center = bounds.getCenter();

    const [roadsData, setRoadsData] = useState(null);
    const [userPosition, setUserPosition] = useState(null);
    const [currentStreetName, setCurrentStreetName] = useState('');

    useEffect(() => {
        fetch('/api/roads')
            .then((res) => res.json())
            .then((data) => {
                setRoadsData(data);
            })
            .catch((err) => console.error('Ошибка загрузки данных:', err));
    }, []);

    const handlePositionUpdate = (coords) => {
        setUserPosition(coords);
    };

    const handleStreetNameUpdate = (streetName) => {
        setCurrentStreetName(streetName);
    };


    return (
        <RouteProvider>
            <FilterProvider>
                <SearchProvider
                    initialRoadsData={roadsData}
                    userPosition={userPosition}
                >

                    <div style={{ width: '100%', height: '100vh' }}>
                        <ModalStackProvider>
                            <Router>
                                <MapContainer
                                    center={center}
                                    zoom={15}
                                    minZoom={15}
                                    maxZoom={18}
                                    zoomControl={false}
                                    style={{ height: '100%', width: '100%' }}
                                    maxBounds={bounds}
                                    maxBoundsViscosity={0.8}
                                >
                                    <TileLayer
                                        url={`${process.env.PUBLIC_URL}/tiles/{z}/{x}/{y}.png`}
                                        attribution='<a href="https://www.maptiler.com/engine/">Rendered with MapTiler Engine</a>, non-commercial use only'
                                        tms={false}
                                        keepBuffer={5}
                                    />
                                    <MapComponents
                                        roadsData={roadsData}
                                        bounds={bounds}
                                        userIcon={userIcon}
                                        handlePositionUpdate={handlePositionUpdate}
                                        handleStreetNameUpdate={handleStreetNameUpdate}
                                        currentStreetName={currentStreetName}
                                    />
                                </MapContainer>
                            </Router>
                        </ModalStackProvider>
                    </div>

                </SearchProvider>
            </FilterProvider>
        </RouteProvider>
);
}

export default App;
